/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A request to update a record in SendGrid contact list collection.
 */
export interface UpdateSendGridContactListRequest { 
    /**
     * The new string identifying a single list on SendGrid.
     */
    listId: string;
    /**
     * Two-letter language code associated with a specific SendGrid list. May be null as the FE             currently does not support changing language, but may be present if the support is implemented.
     */
    language?: string | null;
}

